import { PALETTE, type DisplayColor } from "@mmm/contracts";
import { ColorDot, useT } from "@mmm/ui";
interface ColorSwatchPickerProps {
  value: DisplayColor;
  onChange: (color: DisplayColor) => void;
  square?: boolean;
}

export function ColorSwatchPicker({ value, onChange, square = false }: ColorSwatchPickerProps) {
  const t = useT();
  return (
    <div className="mmm-color-swatches">
      {PALETTE.map((color) => (
        <button
          key={color}
          type="button"
          aria-label={t("common.selectColor", { color })}
          className="mmm-color-swatch-button"
          onClick={() => onChange(color)}
        >
          <ColorDot color={color} size="lg" square={square} selected={value === color} bordered />
        </button>
      ))}
    </div>
  );
}
